import BaseAbility from 'umg-ember-backend/abilities/base';

export default class A11yScanAbility extends BaseAbility {}
